import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  Textarea,
  VStack,
  Heading,
  SimpleGrid,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { createTicket } from "../logic/ticketLogic";
import { fetchUsers } from "../logic/userLogic";
import { fetchCategories } from "../logic/categoryLogic";
import { useAuth } from "../../../../../src/contexts/AuthContext";

export default function TicketForm() {
  const cardBg = useColorModeValue("white", "navy.700");
  const toast = useToast();
  const navigate = useNavigate();

const { token, id_pegawai: idPegawai, getDashboardPath } = useAuth();

  const [users, setUsers] = useState([]);
  const [categories, setCategories] = useState([]);

  const [form, setForm] = useState({
    subject: "",
    description: "",
    user_id: idPegawai || "", // default dari localStorage
    category_id: "",
    assigned_to: "",
    urgensi: "rendah",
  });

  const [loading, setLoading] = useState(false);

  // Fetch Users & Categories saat component mount
  useEffect(() => {
    const loadData = async () => {
      try {
        const usersData = await fetchUsers(token);
        setUsers(usersData || []);

        const categoriesData = await fetchCategories(token);
        setCategories(categoriesData || []);
      } catch (error) {
        toast({
          title: "Gagal memuat data",
          description: error.response?.data?.message || "Terjadi kesalahan",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    };
    loadData();
  }, [token, toast]);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await createTicket(form, token);

      toast({
        title: "Ticket berhasil dibuat",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      setTimeout(() => {
         navigate(getDashboardPath(), { replace: true });
      }, 200);

    } catch (error) {
      toast({
        title: "Gagal membuat ticket",
        description: error.response?.data?.message || "Terjadi kesalahan",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box bg={cardBg} p='30px' borderRadius='20px' boxShadow='sm'>
      <Heading size='md' mb='20px'>
        Create Ticket
      </Heading>

      <VStack spacing='20px' align='stretch'>
        <FormControl isRequired>
          <FormLabel>Subject</FormLabel>
          <Input
            name='subject'
            value={form.subject}
            onChange={handleChange}
          />
        </FormControl>

        <FormControl isRequired>
          <FormLabel>Description</FormLabel>
          <Textarea
            name='description'
            value={form.description}
            onChange={handleChange}
            rows={5}
          />
        </FormControl>

        <SimpleGrid columns={{ base: 1, md: 2 }} spacing='20px'>
          <FormControl isRequired>
            <FormLabel>Karyawan Pembuat Ticket</FormLabel>
            <Select
              name='user_id'
              value={form.user_id}
              onChange={handleChange}
            >
              <option value=''>Pilih user</option>
              {users?.map((u) => (
                <option key={u.id} value={u.id}>
                  {u.name}
                </option>
              ))}
            </Select>
          </FormControl>

          <FormControl isRequired>
            <FormLabel>Category</FormLabel>
            <Select
              name='category_id'
              value={form.category_id}
              onChange={handleChange}
            >
              <option value=''>Pilih kategori</option>
              {categories?.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name}
                </option>
              ))}
            </Select>
          </FormControl>
        </SimpleGrid>

        <SimpleGrid columns={{ base: 1, md: 2 }} spacing='20px'>
          <FormControl>
            <FormLabel>Assigned To</FormLabel>
            <Select
              name='assigned_to'
              value={form.assigned_to}
              onChange={handleChange}
            >
              <option value=''>Opsional</option>
              {users?.map((u) => (
                <option key={u.id} value={u.id}>
                  {u.name}
                </option>
              ))}
            </Select>
          </FormControl>

          <FormControl isRequired>
            <FormLabel>Urgensi</FormLabel>
            <Select
              name='urgensi'
              value={form.urgensi}
              onChange={handleChange}
            >
              <option value='rendah'>Rendah</option>
              <option value='sedang'>Sedang</option>
              <option value='tinggi'>Tinggi</option>
            </Select>
          </FormControl>
        </SimpleGrid>

        <Button
          mt='10px'
          colorScheme='blue'
          size='lg'
          alignSelf='flex-end'
          isLoading={loading}
          onClick={handleSubmit}
        >
          Submit Ticket
        </Button>
      </VStack>
    </Box>
  );
}
